import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import { getTransactionDocShippingaddress } from "../../../api/transaction-type";

import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Checkbox,
  FormControlLabel,
  FormGroup,
  CircularProgress,
} from "@mui/material";

export default function SalesOrderShipping({
  tabIndexP,
  shippingCost,
  shippingMethod,
}) {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);

  const pageDetail = slugMap[params.slug];

  const [rowData, setRowData] = useState([]);
  const [trackingnumberData, setTrackingnumberData] = useState("");

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  useEffect(() => {
    if (user.token && tabIndexP === 1) {
      getTransactionShippingAddressData();
    }
  }, [tabIndexP]);

  async function getTransactionShippingAddressData() {
    setLoading(true);
    try {
      const { data } = await getTransactionDocShippingaddress(user.token, {
        id: params.docNo,
      });
      setRowData(data.data.data);
      setTrackingnumberData(data.data.trackingnumber);
      setLoading(false);
      //return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      setLoading(false);
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

 return loading ? (
       <>
           <Box className="viewDetilsBox">
             <Grid container className="mb-2">
               <Grid item xs={12}>
                 <div
                   style={{
                     width: "100%",
                     display: "flex",
                     justifyContent: "center",
                     alignItems: "center",
                   }}
                 >
                   <CircularProgress></CircularProgress>
                 </div>
               </Grid>
             </Grid>
           </Box>
       </>
     ) : (
    <Box className="viewDetilsBox">
      <>
        {rowData.map((d, i) => (
          <Grid container className="mb-2">
            <Grid item xs={12} sm={6}>
              <Grid container>
                <Grid item xs={12} md={12} className="m-b-10">
                  <p className="titleHeading m-0">Shipping Information</p>
                </Grid>
                <Grid item xs={6} md={6} className="m-b-10">
                  <p className="tFormlabel">SHIP DATE</p>
                  <p className="tFormName">{d.shipdate}</p>
                </Grid>
                <Grid item xs={6} md={6} className="m-b-10">
                  <p className="tFormlabel">ACTUAL DATE</p>
                  <p className="tFormName">{d.actualshipdate}</p>
                </Grid>
                <Grid item xs={12} className="m-b-10">
                  <p className="tFormlabel">SHIPPING CARRIER</p>
                  <p className="tFormName">{d.shipcarrier}</p>
                </Grid>
                <Grid item xs={12} className="m-b-10">
                  <p className="tFormlabel">SHIPPING METHOD</p>
                  <p className="tFormName">{d.shipping_method}</p>
                </Grid>
                {d.ship_complete === "F" || d.ship_complete === "" ? (
                  <Grid item xs={12} className="m-b-10">
                    <p className="tFormlabel">
                      <FormGroup>
                        <FormControlLabel
                          control={<checkbox  disabled/>}
                          label="SHIP COMPLETE"
                        />
                      </FormGroup>
                    </p>
                  </Grid>
                ) : (
                  <Grid item xs={12} className="m-b-10">
                    <p className="tFormlabel">
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked />}
                          label="SHIP COMPLETE"
                        />
                      </FormGroup>
                    </p>
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid container className="mb-2">
                <Grid item xs={12} md={12} className="m-b-10">
                  <p className="titleHeading m-0">Shipping Address</p>
                </Grid>
                {/* <Grid item xs={12}>
                  <p className="tFormlabel">SHIP TO</p>
                  <p className="tFormName">{d.ship_to}</p>
                </Grid> */}
                <Grid item xs={12} className="m-b-10">
                  <p className="tFormlabel">SHIPPING CODE (2)</p>
                  <p className="tFormName">{d.shipping_code}</p>
                </Grid>
                {/* <Grid item xs={12} className="m-b-10">
                  <p className="tFormlabel">SHIP TO COUNTRY</p>
                  <p className="tFormName">{d.ship_to_country}</p>
                </Grid> */}
              </Grid>
            </Grid>
          </Grid>
        ))}
      </>
    </Box>
    // <Box className="viewDetilsBox">
    //   <>
    //     {rowData.map((d, i) => (
    //       <Grid container className="mb-2">
    //         <Grid item xs={12} sm={6}>
    //           <Grid container className="mb-2">
    //             <Grid item xs={12} className="m-b-10">
    //               <p className="fromHeading">Shipping Information</p>
    //               <p className="tFormlabel">SHIPPING INCO TERM</p>
    //               <p className="tFormName">{d.custbody_shipping_inco_term}</p>
    //             </Grid>
    //             <Grid item xs={6} className="m-b-10">
    //               <p className="tFormlabel">EST SHIP DATE</p>
    //               <p className="tFormName">{d.shipdate}</p>
    //             </Grid>
    //             <Grid item xs={6} className="m-b-10">
    //               <p className="tFormlabel">ACTUAL DATE</p>
    //               <p className="tFormName">{d.actualshipdate}</p>
    //             </Grid>
    //             <Grid item xs={12} className="m-b-10">
    //               <p className="tFormlabel">SHIPPING CARRIER</p>
    //               <p className="tFormName">{d.shipcarrier}</p>
    //             </Grid>
    //             <Grid item xs={12} className="m-b-10">
    //               <p className="tFormlabel">SHIPPING METHOD</p>
    //               <p className="tFormName">{shippingMethod}</p>
    //             </Grid>
    //             <Grid item xs={12} className="m-b-10">
    //               <p className="tFormlabel checkAndTextAlign">
    //                 {d.custbodycustcol_custppdship == "F" ? (
    //                   <>
    //                     <FormGroup>
    //                       <FormControlLabel
    //                         control={<Checkbox disabled />}
    //                         label=""
    //                       />
    //                     </FormGroup>
    //                     CUST PPD SHIP
    //                   </>
    //                 ) : (
    //                   <>
    //                     <FormGroup>
    //                       <FormControlLabel
    //                         control={<Checkbox checked disabled />}
    //                         label=""
    //                       />
    //                     </FormGroup>
    //                     CUST PPD SHIP
    //                   </>
    //                 )}
    //               </p>
    //             </Grid>
    //             <Grid item xs={12} className="m-b-10">
    //               <p className="tFormlabel">SHIPPING COST</p>
    //               <p className="tFormName">{shippingCost}</p>
    //             </Grid>
    //             <Grid item xs={12} className="m-b-10">
    //               <p className="tFormlabel checkAndTextAlign">
    //                 {d.shipcomplete == "F" ? (
    //                   <>
    //                     <FormGroup>
    //                       <FormControlLabel
    //                         control={<Checkbox disabled />}
    //                         label=""
    //                       />
    //                     </FormGroup>
    //                     SHIP COMPLETE
    //                   </>
    //                 ) : (
    //                   <>
    //                     <FormGroup>
    //                       <FormControlLabel
    //                         control={<Checkbox checked disabled />}
    //                         label=""
    //                       />
    //                     </FormGroup>
    //                     SHIP COMPLETE
    //                   </>
    //                 )}
    //               </p>
    //             </Grid>
    //             <Grid item xs={12} className="m-b-10">
    //               <p className="tFormlabel">SHIPPING TAX CODE</p>
    //               <p className="tFormName"></p>
    //             </Grid>
    //             <Grid item xs={12} className="m-b-10">
    //               <p className="tFormlabel">TAX RATE</p>
    //               <p className="tFormName"> {d.custbody_tax_rate}</p>
    //             </Grid>
    //             <Grid item xs={12} className="m-b-10">
    //               <p className="tFormlabel">SHIPPING ACCOUNT #</p>
    //               <p className="tFormName">
    //                 {d.custbody_shipping_account_number}
    //               </p>
    //             </Grid>
    //             <Grid item xs={12} className="m-b-10">
    //               <p className="tFormlabel">SHIPPING NOTES</p>
    //               <p className="tFormName">{d.custbody_shipping_notes}</p>
    //             </Grid>
    //             <Grid item xs={12} className="m-b-10">
    //               <p className="tFormlabel">SHIPPING CODE (2)</p>
    //               <p className="tFormName"></p>
    //             </Grid>
    //             <Grid item xs={12} className="m-b-10">
    //               <p className="tFormlabel">IMPORTER OF RECORD</p>
    //               <p className="tFormName">{d.custbody_importer_of_record}</p>
    //             </Grid>
    //             <Grid item xs={12} className="m-b-10">
    //               <p className="tFormlabel">FREIGHT FORWARDER</p>
    //               <p className="tFormName">{d.custbody_freight_forwarder}</p>
    //             </Grid>
    //             <Grid item xs={12} className="m-b-10">
    //               <p className="tFormlabel">TRACKING #</p>
    //               <p className="tFormName">{trackingnumberData}</p>
    //             </Grid>
    //           </Grid>
    //         </Grid>
    //         <Grid item xs={12} sm={6}>
    //           <Grid container className="mb-2">
    //             <Grid item xs={12} className="m-b-10">
    //               <p className="fromHeading">Shipping Address</p>
    //               <p className="tFormlabel">SHIP TO</p>
    //               <p className="tFormName">{d.ship_to}</p>
    //             </Grid>
    //             <Grid item xs={12} className="m-b-10">
    //               <p className="tFormlabel">EA EMAIL</p>
    //               <p className="tFormName">{d.custbody_ea_email}</p>
    //             </Grid>
    //             <Grid item xs={12} className="m-b-10">
    //               <p className="tFormlabel">EA FIRST NAME</p>
    //               <p className="tFormName">{d.custbody_ea_first_name}</p>
    //             </Grid>
    //             <Grid item xs={12} className="m-b-10">
    //               <p className="tFormlabel">EA LAST NAME</p>
    //               <p className="tFormName">{d.custbody_ea_last_name}</p>
    //             </Grid>
    //           </Grid>
    //         </Grid>
    //       </Grid>
    //     ))}
    //   </>
    // </Box>
  );
}
